export default {
  appKey: 4001,
  fcode: '1000002',
  routerBase: '/',
  baseUrl: '/gfw',
  socketUrl: 'ws.ymt.com/'
}
